const sealedUnsealedInfo = {
  sealed:
    "Single lane Hwy. Please take caution and pull well off the road when stopping. At certain times of the year these roads are used by semi trailers taking grain to CBH bins.",
  unsealed:
    "Gravel roads can become corrugated during the season but are generally accessible to 2WDs.",
};

export { sealedUnsealedInfo };
